import { useEffect, useState } from "react";
import { db } from "@healthdesk/shared-services";
import {
  MAP_CAROUSEL_COLLECTION,
  MAP_CAROUSEL_DOC_ID,
  normalizeMapCarouselDocument,
} from "../services/mapCarousel";

/**
 * Live subscription to `publicConfig/mapCarousel` for anonymous + authenticated map users.
 * On error, falls back to defaults (legacy merge behavior).
 */
const useMapCarouselGlobalConfig = () => {
  const [state, setState] = useState(() => ({
    loading: true,
    config: normalizeMapCarouselDocument(null),
    rawExists: false,
    error: null,
  }));

  useEffect(() => {
    const ref = db.collection(MAP_CAROUSEL_COLLECTION).doc(MAP_CAROUSEL_DOC_ID);
    const unsubscribe = ref.onSnapshot(
      (snap) => {
        const data = snap.exists ? snap.data() : null;
        setState({
          loading: false,
          config: normalizeMapCarouselDocument(data),
          rawExists: snap.exists,
          error: null,
        });
      },
      (err) => {
        // Common before rules are deployed, or wrong Firebase project: fall back to built-in defaults.
        const code = err?.code || err?.message;
        if (code === "permission-denied" || String(code).includes("permission")) {
          console.debug(
            "useMapCarouselGlobalConfig: no read access to publicConfig/mapCarousel (using defaults). Deploy firestore rules if this should be allowed."
          );
        } else {
          console.warn("useMapCarouselGlobalConfig: snapshot failed", err);
        }
        setState({
          loading: false,
          config: normalizeMapCarouselDocument(null),
          rawExists: false,
          error: err,
        });
      }
    );
    return () => unsubscribe();
  }, []);

  return state;
};

export default useMapCarouselGlobalConfig;
